import React, { Component } from "react";
import ModalWindow from "Orgs/ModalWindow";
import WelcomeLoader from "Orgs/Loader/WelcomeLoader";


class Loader extends Component{
	state = {
		welcomeToggle: false,
		modalScreen: false
	}

	timerHandle = () => {
		setTimeout(() => {
			this.setState({
				modalScreen: false
			})
		}, 1500);
	}

	componentWillUnmount = () => {
		clearTimeout(this.timerHandle);
		this.timerHandle = 0;
	 };

	componentWillReceiveProps(nextProps){
		if(nextProps.isLoading){
			this.setState({
				welcomeToggle: false,
				modalScreen: true
			})
		} else if(nextProps.isLoadingWithError){
			this.setState({
				welcomeToggle: false,
			}, this.timerHandle)
		}
		else {
			this.setState({
				welcomeToggle: true,
			}, this.timerHandle)
		}
	}

	render(){
		const { welcomeToggle, modalScreen } = this.state;
		return (
			<ModalWindow
				modal={modalScreen}
				custom={{
					content: {
						width: "30%",
						height: "calc(width * 3)",
						backgroundColor: "rgba(255, 255, 255, 1)",
						borderRadius: "10px",
						display: "flex",
						flexDirection: "column"
					},
					overlay: {
						opacity: 1.0
					}
				}}>

				{
					welcomeToggle ? <WelcomeLoader/> :
					(
						<div className="com-loader spinner">
							<div className="dx-col">
								<div className="loader-content">
									<img src="/media/icons/loading.svg" className="loginSpinnerIcon" alt="Loading"/>
									<div className="loader-text">
										We know your time is valuable
										this will only be a moment&#46;
									</div>
								</div>
							</div>
						</div>
					)
				}
			</ModalWindow>
		);
	}

}


export default Loader;



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/Loader/Loader.js